import get from 'lodash/get'
import { Map } from 'immutable'
import {
  SET_APP_BOOTSTRAP_PHASE,
  SET_APP_SCROLLABLE,
  SET_APP_RENDERABLE,
  SET_APP_VIEWPORT,
  SET_APP_HEADER,
  SET_APP_LAST_INTERACTED_TIMESTAMP,
  SET_APP_IS_INITIAL_RENDER,
} from './actions'

export const initialState = Map({
  viewport: Map({ width: 0, height: 0, ready: false }),
})

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SET_APP_BOOTSTRAP_PHASE: {
      const { payload = {} } = action
      const { phase, isComplete = false } = payload
      return state.set('bootstrapComplete', isComplete)
        .set('bootstrapPhase', phase)
    }
    case SET_APP_RENDERABLE: {
      const isWebView = state.get('isWebView')
      const shouldRender = !!get(action, 'payload', true)
      return state.set('renderApp', shouldRender)
        .set('renderHeader', shouldRender && !isWebView)
        .set('renderFooter', shouldRender && !isWebView)
    }
    case SET_APP_SCROLLABLE: {
      const scrollable = !!get(action, 'payload', true)
      return state.set('scrollable', scrollable)
    }
    case SET_APP_VIEWPORT: {
      const viewport = Map(get(action, 'payload', {}))
      return state.set('viewport', viewport)
    }
    case SET_APP_HEADER: {
      const shouldRender = !!get(action, 'payload', true)
      return state.set('renderHeader', shouldRender)
    }
    case SET_APP_LAST_INTERACTED_TIMESTAMP: {
      return state.set('lastInteractedTimestamp', action.payload)
    }
    case SET_APP_IS_INITIAL_RENDER:
      return state.set('isInitialRender', action.payload)
    default:
      return state
  }
}
